import { Component, DestroyRef, inject, input, OnInit, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MenuItem } from '@app/models/menu/MenuItem';
import { Partner } from '@app/models/partner/IPartner';
import { AuthGuardService } from '@app/services/auth-guard.service';

@Component({
    selector: 'app-globalmenu-item1',
    templateUrl: './globalmenu-item.component.html',
    styleUrls: ['./globalmenu-item.component.scss'],
    standalone: false
})
export class GlobalmenuItemComponent1 implements OnInit {
    readonly data = input<MenuItem>(undefined);
    readonly zindex = input<number>(undefined);
    readonly opensubmenu = output<any>();
    readonly openLink = output<any>();
    loading: boolean = false;
    openSubmenu: boolean = false;
    menuopen: boolean = true;
    destroyRef = inject(DestroyRef);
    partner: Partner;
    constructor(
        protected guardService: AuthGuardService,
    ) { }

    ngOnInit(): void {
        this.initPartner();
    }

    async initPartner() {
        this.guardService.getPartner$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((obj) => {
                if (obj?.partnerid?.length > 0) {
                    this.partner = obj;
                }
            });
    }

    async openSubmenuList(ev) {
        ev.stopPropagation();
        const data = this.data();
        if (data?.list?.length > 0) {
            this.opensubmenu.emit(data);
        } else {
            this.openLink.emit(data);
        }
    }
}
